import Carousel from 'embla-carousel';

const loadCaseStudiesCarousel = () => {
  const carouselNode = document.querySelector('.products-used');
  const viewport = document.querySelector('.products-used--viewport');

  if (carouselNode && viewport) {
    const carousel = Carousel(viewport, {
      loop: false,
      draggableClass: 'cursor-grab',
      draggingClass: 'cursor-grabbing',
      align: 'start',
      containScroll: 'trimSnaps'
    });

    const onCarouselSelect = () => {
      const index = carousel.selectedScrollSnap();
      carousel.slideNodes().forEach((el, i) => el.classList.toggle('is-active', i === index));
    };

    const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
      prevBtn.addEventListener('click', embla.scrollPrev, false);
      nextBtn.addEventListener('click', embla.scrollNext, false);
    };

    const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
      return () => {
        if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');
        else prevBtn.setAttribute('disabled', 'disabled');

        if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');
        else nextBtn.setAttribute('disabled', 'disabled');
      };
    };

    const prevBtn = document.querySelector('[data-button="prev"]');
    const nextBtn = document.querySelector('[data-button="next"]');
    const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, carousel);

    setupPrevNextBtns(prevBtn, nextBtn, carousel);

    onCarouselSelect();

    carousel.on('init', disablePrevAndNextBtns);
    carousel.on('select', onCarouselSelect);
    carousel.on('select', disablePrevAndNextBtns);
  } else {
    return;
  }
};

export default loadCaseStudiesCarousel;
